var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('n8n-notice',{attrs:{"content":_vm.scopesShortContent,"fullContent":_vm.scopesFullContent}})}
var staticRenderFns = []

export { render, staticRenderFns }